import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Line from './../line'
const Wrapper = styled.div`
  color: var(--cPrimary);
  display: flex;
  flex-direction: column;
  i {
    color: var(--cPrimaryLight);
  }
`

const Sup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  @media(max-width: 919px) {
    justify-content: center;
  }
`
const SupTitle = styled.h3`
  font-size: 1rem;
  line-height: 0;
  @media(max-width: 919px) {
    text-align: center;
  }
`
const Title = styled.h2`
  margin-top: 10px;
  font-size: 2rem;
  line-height: 42px;
  @media(max-width: 919px) {
    text-align: center;
  }
`
const Description = styled.div`
 * {
  font-size: 1rem;
  font-weight: 300;
  line-height: 25px;
  @media(max-width: 919px) {
    text-align: center;
  }
 }
  
`
const TitleGroup = ({ icon, supTitle, title, children }) => (
  <Wrapper>
    <Sup>
      <i className={icon} />
      <SupTitle>{supTitle}</SupTitle>
    </Sup>
    
    <Title>{title}</Title>
    <Line width="16px" align="left" />
    <Description>{children}</Description>
  </Wrapper>
)


TitleGroup.propTypes = {
  icon: PropTypes.string,
  supTitle: PropTypes.string,
  title: PropTypes.string,
}
TitleGroup.defaultProps = {
  icon: '',
  supTitle: '',
  title: '',
}
export default TitleGroup
